import { render, staticRenderFns } from "./agregaObservaciones.vue?vue&type=template&id=d36db844"
import script from "./agregaObservaciones.vue?vue&type=script&lang=js"
export * from "./agregaObservaciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports